import React from "react"
import LandingPage from "../sections/LandingPage";
import Statistics from "../sections/Statistics";
import PropertiesSection from "../sections/PropertiesSection";
import PopularProperties from "../sections/PopularProperties";
import GetStarted from "../sections/GetStarted";
import PerfectHome from "../sections/PerfectHome";
import GetInTouch from "../sections/GetInTouch";
import Partners from "../sections/Partners";
export default function Home() {
    return (
        <>
            <LandingPage />
            <Partners/>
            <PropertiesSection/>
            <PopularProperties/>
            <PerfectHome/>
            <GetInTouch/>
            <Statistics />
            <GetStarted/>
        </>
    )
}